import { resolveDefaultContentLanguage } from '@/entities/transcriptor';

import { LANGUAGE_FILTER_ALL } from '../config';

type ResolveTemplateListLanguageArgs = {
  languageParam: string | null;
  availableLanguages: string[];
  locale: string;
};

export const resolveTemplateListLanguage = ({
  languageParam,
  availableLanguages,
  locale,
}: ResolveTemplateListLanguageArgs): string => {
  if (languageParam === null) {
    return resolveDefaultContentLanguage({ locale, availableLanguages });
  }

  const normalized = languageParam.toLowerCase();

  if (
    normalized === LANGUAGE_FILTER_ALL ||
    availableLanguages.includes(normalized)
  ) {
    return normalized;
  }

  return LANGUAGE_FILTER_ALL;
};
